angular.module('ihestiaCommonDirectives.starRating', []);